export const CHAT_WIDTH = 340;
export const CHAT_HEIGHT = 560;
export const CHAT_MAX_WIDTH = 769;
